


























































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import Env from '@finx/web-repository/src/services/Env'
import BackofficeNavigationStore from '@/components/Backoffice/NavBar/Store/BackofficeNavigationStore'
import LogoutConfigStore from '@/store/LogoutConfigStore'
import { toggleTheme, isDarkTheme } from '@/utils/theme'

@Component

export default class ComponentBackofficeTopNavBar extends Vue {
  mdAjuda: boolean = false
  isDark: boolean = isDarkTheme()

  get podePersonificar(): boolean {
    const user = this.$user
    const authorized = user && user.profile && Array.isArray(user.profile.pageAuthorized)
      ? user.profile.pageAuthorized
      : []
    const hasPermission = authorized.includes('suporte-personificar')
    const isImpersonating = sessionStorage.getItem('IMPERSONATION_ACTIVE') === 'true'
    return hasPermission || isImpersonating
  }

  alternarTema() {
    toggleTheme()
    this.isDark = isDarkTheme()
  }

  get modalAjuda() { return this.mdAjuda }
  set modalAjuda(value: boolean) { this.mdAjuda = value }

  get logoutConfigStore() {
    return getModule(LogoutConfigStore, this.$store)
  }

  get getBackofficeNavigationStore() {
    return getModule(BackofficeNavigationStore, this.$store)
  }

  get drawer() {
    return !!this.getBackofficeNavigationStore.navigationDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeNavigationStore.setNavigationDrawer(value)
  }

  get miniSync() {
    return !!this.getBackofficeNavigationStore.miniSync
  }

  set miniSync(value: boolean) {
    this.getBackofficeNavigationStore.setMiniSync(value)
    localStorage.setItem('miniSync', String(this.getBackofficeNavigationStore.miniSync))
  }

  trocarSenha(): void {
    this.$ga.event('autenticacao', 'alterar-senha', this.$user.profile.email)
    window.location.href = `${Env.API_FINX_AUTH}ChangePassword`
  }

  async logout() {
    await this.logoutConfigStore.authLogout(this.$user.profile.sub)
  }

  goTo(rota: string) {
    this.$router.push(rota)
  }

  redirectoToDocumentsPage() {
    this.$router.push({ name: 'hospital-profile-documents' })
  }

  redirectToPortalMedico() {
    this.$router.push('/agendamento-medico')
  }

  setMiniSync() {
    if (localStorage.getItem('miniSync') === null) localStorage.setItem('miniSync', String(false))
    this.getBackofficeNavigationStore.setMiniSync(localStorage.getItem('miniSync') === 'true')
  }

  created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
    this.$nextTick(() => {
      window.addEventListener('resize', this.setMiniSync)
      this.setMiniSync()
    })
  }

  destroyed() {
    window.removeEventListener('resize', this.setMiniSync)
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.altKey && event.code === 'Escape') this.miniSync = !this.miniSync
  }
}
